import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/pricing');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Paper elevation={3} sx={{ p: 5, borderRadius: 4 }}>
        <CancelOutlinedIcon sx={{ fontSize: 80, color: '#f44336', mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Subscription Cancelled
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The checkout process was cancelled. No charges were made to your account.
        </Typography>
        <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
          Redirecting you back to pricing plans...
        </Typography>
        <Button 
          variant="outlined" 
          color="primary" 
          size="large"
          onClick={() => navigate('/pricing')}
          sx={{ borderRadius: 2, px: 4 }}
        >
          Return to Pricing
        </Button>
      </Paper>
    </Container>
  );
};

export default SubscriptionCancel;

